import _ from "lodash";
import {
    RECEIVE_DOCUMENT_REPOSITORY_ATTACHMENTS,
    RECEIVE_DOCUMENT_REPOSITORY_ATTACHMENTS_FILTER,
    FETCH_DOCUMENT_REPOSITORY_ATTACHMENTS_REQUEST,
    FETCH_DOCUMENT_REPOSITORY_ATTACHMENTS_FILTER_REQUEST,
    EXPORT_DOCUMENT_REPOSITORY_ATTACHMENT_REQUEST,
    EXPORT_DOCUMENT_REPOSITORY_ATTACHMENT_DONE,
    MESSAGE_DOCUMENT_REPOSITORY_ATTACHMENT,
    CLEAR_DOCUMENT_REPOSITORY_ATTACHMENT_PAGINATION,
    EXPORT_DOCUMENT_REPOSITORY_ATTACHMENTS_REQUEST,
    EXPORT_DOCUMENT_REPOSITORY_ATTACHMENTS_DONE,
    CLEAR_DOCUMENT_REPOSITORY_ATTACHMENTS_CACHE,
    SET_ITEMS_OFFSET,
    SET_FILTERS,
    LOGOUT_SUCCESS
} from '../../../constants';
import { createReducer } from '../../../utils/misc';

const initialState = {
    data: {},
    categories: [],
    download_message: null,
    isFetching: false,
    loaded: false,
    download_status: {},
    attachmentsCache: {},
    flatAttachments: null,
    electricityAttachments: {},
    gasAttachments: {},
    itemsPage: 10,
    itemsTotal: 0,
    itemsOffset: 0,
    filters: {
        loading: false,
        data: {},
        currentFilter: ''
        // cache: {}
    },
    errors: null
};

export default createReducer(initialState, {
    [RECEIVE_DOCUMENT_REPOSITORY_ATTACHMENTS]: (state, payload) => {
        const response = payload.response || {};
        const attachmentsCache = payload.cacheKey && !payload.errors
            ? {
                ...state.attachmentsCache,
                [payload.cacheKey]: response
            }
            : state.attachmentsCache;

        // Detect flat format (new unified model) vs nested (legacy)
        const isFlatFormat = Array.isArray(response.attachments);

        if (isFlatFormat) {
            return Object.assign({}, state, {
                flatAttachments: response.attachments,
                electricityAttachments: {},
                gasAttachments: {},
                categories: response.categories || [],
                itemsTotal: response.total || 0,
                itemsOffset: response.offset || 0,
                itemsPage: response.limit || state.itemsPage,
                attachmentsCache,
                isFetching: false,
                loaded: true,
                message_text: payload.message,
                errors: payload.errors,
                contracts: response.contracts
            });
        }

        // Legacy nested format
        const result = response.result || {};
        const electricity = result.electricity || {};
        const gas = result.gas || {};

        return Object.assign({}, state, {
            flatAttachments: null,
            electricityAttachments: electricity,
            gasAttachments: gas,
            categories: response.categories || [],
            itemsTotal: response.total || 0,
            itemsOffset: response.offset || 0,
            itemsPage: response.limit || state.itemsPage,
            attachmentsCache,
            isFetching: false,
            loaded: true,
            message_text: payload.message,
            errors: payload.errors,
            contracts: response.contracts
        })
    },
    [SET_ITEMS_OFFSET]: (state, payload) =>
        Object.assign({}, state, {
            itemsOffset: payload.itemsOffset
        }),
    [SET_FILTERS]: (state, payload) =>
        Object.assign({}, state, {
            itemsPage: payload.itemsPage,
            itemsOffset: payload.itemsOffset,
            filters: {
                ...state.filters,
                currentFilter: payload.currentFilter
            }
        }),
    [CLEAR_DOCUMENT_REPOSITORY_ATTACHMENT_PAGINATION]: (state, payload) =>
        Object.assign({}, state, {
            itemsPage: 10,
            itemsTotal: 0,
            itemsOffset: 0,
        }),
    [CLEAR_DOCUMENT_REPOSITORY_ATTACHMENTS_CACHE]: (state, payload) =>
        Object.assign({}, state, {
            attachmentsCache: {}
        }),
    [RECEIVE_DOCUMENT_REPOSITORY_ATTACHMENTS_FILTER]: (state, payload) =>
        Object.assign({}, state, {
            filters: {
                ...state.filters,
                loading: false,
                data: payload
            }
        }),
    [FETCH_DOCUMENT_REPOSITORY_ATTACHMENTS_REQUEST]: (state, payload) =>
        Object.assign({}, state, {
            isFetching: true,
            loaded: false,
            message_text: payload.message,
        }),
    [FETCH_DOCUMENT_REPOSITORY_ATTACHMENTS_FILTER_REQUEST]: (state, payload) =>
        Object.assign({}, state, {
            filters: {
                ...state.filters,
                loading: true,
                data: {}
            }
        }),
    [EXPORT_DOCUMENT_REPOSITORY_ATTACHMENT_REQUEST]: (state, payload) => {
        const download_status = Object.assign({}, state.download_status);
        download_status[payload.attachmentKey] = true;
        return Object.assign({}, state, {
            download_status,
            message_text: payload.message
        });
    },
    [EXPORT_DOCUMENT_REPOSITORY_ATTACHMENT_DONE]: (state, payload) => {
        const download_status = Object.assign({}, state.download_status);
        download_status[payload.attachmentKey] = false;
        return Object.assign({}, state, {
            download_status
        });
    },
    [EXPORT_DOCUMENT_REPOSITORY_ATTACHMENTS_REQUEST]: (state, payload) => {
        return Object.assign({}, state, {
            download_all_status: true
        });
    },
    [EXPORT_DOCUMENT_REPOSITORY_ATTACHMENTS_DONE]: (state, payload) => {
        return Object.assign({}, state, {
            download_all_status: false
        });
    },
    [MESSAGE_DOCUMENT_REPOSITORY_ATTACHMENT]: (state, payload) => {
      return Object.assign({}, state, {
            download_message: payload.message,
        })
    },
    [LOGOUT_SUCCESS]: (state, payload) =>
        Object.assign({}, state, initialState),
});
